import { render, staticRenderFns } from "./DetailTabData.vue?vue&type=template&id=9208ebae"
import script from "./DetailTabData.vue?vue&type=script&lang=js"
export * from "./DetailTabData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports